"use client"

import React from "react"
import { NotificationItemTemplate } from "./NotificationItemTemplate"
import { FragmentType, graphql, useFragment } from "@/gql"
import { ChevronRightIcon } from "@heroicons/react/24/outline"
import { Avatar, Text } from "@/elements"
import { JobPostingLocationType, UserNotificationFeedItem } from "@/gql/graphql"
import { useRouter } from "next-nprogress-bar"

const JobRecommendationBatchCreatedFragment = graphql(`
  fragment JobRecommendationBatchCreated on StreamNotificationFeedAggregatedActivity {
    id
    activityCount
    isSeen
    activities {
      id
      time
      object {
        __typename
        ... on JobRecommendationBatch {
          createdAt
          recommendations(first: 5) {
            totalCount
            edges {
              cursor
              node {
                id
                jobPosting {
                  id
                  position {
                    id
                    name
                  }
                  locationType
                  locationName
                  owner {
                    id
                    name
                    avatar120w: avatar(width: 120)
                    avatarInitials
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`)

interface Props {
  onActorClick: (e: React.MouseEvent<any, MouseEvent>) => void
  onClick: (type: UserNotificationFeedItem) => void
  item: FragmentType<typeof JobRecommendationBatchCreatedFragment>
}

export const JobRecommendationBatchCreated: React.FC<Props> = props => {
  const item = useFragment(JobRecommendationBatchCreatedFragment, props.item)
  const { onActorClick, onClick } = props
  const router = useRouter()
  const activity = item.activities?.[0]
  const object = activity?.object

  const recommendations = object?.__typename === "JobRecommendationBatch" ? object?.recommendations : null

  const jobPosting = recommendations?.edges?.[0]?.node?.jobPosting
  const isRemote = jobPosting?.locationType === JobPostingLocationType.Telecommute

  const handleClick = () => {
    onClick(UserNotificationFeedItem.JobRecommendations)
    // FIXME: Navigate to recommended jobs
    router.push(`/jobs`)
  }

  return (
    <NotificationItemTemplate
      isSeen={item.isSeen}
      onClick={handleClick}
      LeftComponent={
        <div onClick={onActorClick}>
          <Avatar src={jobPosting?.owner?.avatar120w ?? ""} initials={jobPosting?.owner?.avatarInitials} size="sm" />
        </div>
      }
      TextContent={
        <Text element="span">
          <Text element="span" className="!font-medium">
            {jobPosting?.owner?.name ?? "Client"}
          </Text>{" "}
          is hiring a{" "}
          <Text element="span" className="!font-medium">
            {jobPosting?.position?.name ?? "position"}
          </Text>
          {isRemote ? " for a remote role" : ` in ${jobPosting?.locationName ?? "location"}`}.
          {!!recommendations &&
            recommendations?.totalCount > 1 &&
            ` See this and ${recommendations.totalCount - 1} other job recommendation${recommendations.totalCount > 2 ? "s" : ""}.`}
        </Text>
      }
      time={activity?.time}
    />
  )
}
